/* eslint-disable camelcase */

/**
 * The result of this is used to submit the requirements of
 * a brief to our API
 *
 * The summary parameter provided should be the result of
 * `generateSummary()` or have the same structure.
 *
 * @param summary
 * @param files
 */
export function generateBrief(
  summary = [],
  files = {},
  organization,
  serviceHandle
) {
  return {
    service_handle: serviceHandle,
    requirements_attributes: generateRequirements(summary),
    files: generateFileList(files).map(fileObj => fileObj.signedId),
    organization_id: organization ? organization.organizationId : null,
  };
}

function generateFileList(files) {
  return Object.keys(files).reduce((fileList, inputHandle) => {
    return [...fileList, ...files[inputHandle]];
  }, []);
}

function generateRequirements(summary = []) {
  return summary.reduce(reduceRequirements, []);
}

function reduceRequirements(requirementResults, step) {
  return [...requirementResults, ...step.questions.map(mapQuestions)];
}

function mapQuestions(question) {
  return {
    question_handle: question.handle,
    responses_attributes: question.responses.map(mapResponses),
  };
}

function mapResponses(response) {
  return {
    input_handle: response.handle,
    input_type: response.type,
    value: response.value,
  };
}
/* eslint-enable camelcase */
